<template>
    <div class="player-stats-breakdown">
        <div class="breakdown-title">Разбивка по элементам</div>
        <div class="breakdown-table">
            <!-- Атака -->
            <div v-if="stats.attack_total > 0" class="breakdown-row">
                <div class="breakdown-label">Атака</div>
                <div class="breakdown-values">
                    <span class="bv-total">{{ stats.attack_total }}</span>
                    <span v-if="stats.attack_total > 0" class="bv-eff">({{ stats.attack_efficiency }}%)</span>
                    <span class="bv-q" title="Очко">#</span><span class="bv-num">{{ stats.attack_by_quality?.perfect ?? 0 }}</span>
                    <span class="bv-q" title="Усложнено">+</span><span class="bv-num">{{ stats.attack_by_quality?.positive ?? 0 }}</span>
                    <span class="bv-q" title="Не забито">!</span><span class="bv-num">{{ stats.attack_by_quality?.neutral ?? 0 }}</span>
                    <span class="bv-q" title="Плохо">-</span><span class="bv-num">{{ stats.attack_by_quality?.negative ?? 0 }}</span>
                    <span class="bv-q err" title="Блок">/</span><span class="bv-num">{{ stats.attack_by_quality?.slash ?? 0 }}</span>
                    <span class="bv-q err" title="Ошибка">=</span><span class="bv-num">{{ stats.attack_by_quality?.error ?? 0 }}</span>
                </div>
            </div>
            <!-- Подача -->
            <div v-if="stats.serve_total > 0" class="breakdown-row">
                <div class="breakdown-label">Подача</div>
                <div class="breakdown-values">
                    <span class="bv-total">{{ stats.serve_total }}</span>
                    <span class="bv-eff">({{ stats.serve_efficiency }}%)</span>
                    <span class="bv-q">#</span><span class="bv-num">{{ stats.serve_by_quality?.perfect ?? 0 }}</span>
                    <span class="bv-q">+</span><span class="bv-num">{{ stats.serve_by_quality?.positive ?? 0 }}</span>
                    <span class="bv-q">!</span><span class="bv-num">{{ stats.serve_by_quality?.insufficient ?? 0 }}</span>
                    <span class="bv-q">-</span><span class="bv-num">{{ stats.serve_negative ?? 0 }}</span>
                    <span class="bv-q">/</span><span class="bv-num">{{ stats.serve_by_quality?.veryPositive ?? 0 }}</span>
                    <span class="bv-q err">=</span><span class="bv-num">{{ stats.serve_by_quality?.error ?? 0 }}</span>
                </div>
            </div>
            <!-- Блок -->
            <div v-if="stats.block_total > 0" class="breakdown-row">
                <div class="breakdown-label">Блок</div>
                <div class="breakdown-values">
                    <span class="bv-total">{{ stats.block_total }}</span>
                    <span class="bv-q">#</span><span class="bv-num">{{ stats.block_by_quality?.perfect ?? 0 }}</span>
                    <span class="bv-q">+</span><span class="bv-num">{{ stats.block_by_quality?.positive ?? 0 }}</span>
                    <span class="bv-q">!</span><span class="bv-num">{{ stats.block_neutral ?? 0 }}</span>
                    <span class="bv-q">/</span><span class="bv-num">{{ stats.block_by_quality?.invasion ?? 0 }}</span>
                    <span class="bv-q">-</span><span class="bv-num">{{ stats.block_negative ?? 0 }}</span>
                    <span class="bv-q err">=</span><span class="bv-num">{{ stats.block_by_quality?.error ?? 0 }}</span>
                </div>
            </div>
            <!-- Приём -->
            <div v-if="stats.reception_total > 0" class="breakdown-row">
                <div class="breakdown-label">Приём</div>
                <div class="breakdown-values">
                    <span class="bv-total">{{ stats.reception_total }}</span>
                    <span class="bv-eff">({{ stats.reception_efficiency }}%)</span>
                    <span class="bv-q">#</span><span class="bv-num">{{ stats.reception_by_quality?.perfect ?? 0 }}</span>
                    <span class="bv-q">+</span><span class="bv-num">{{ stats.reception_by_quality?.positive ?? 0 }}</span>
                    <span class="bv-q">!</span><span class="bv-num">{{ stats.reception_by_quality?.insufficient ?? 0 }}</span>
                    <span class="bv-q">-</span><span class="bv-num">{{ stats.reception_negative ?? 0 }}</span>
                    <span class="bv-q">/</span><span class="bv-num">{{ stats.reception_by_quality?.veryPoor ?? 0 }}</span>
                    <span class="bv-q err">=</span><span class="bv-num">{{ stats.reception_by_quality?.error ?? 0 }}</span>
                </div>
            </div>
            <!-- Защита -->
            <div v-if="stats.dig_total > 0" class="breakdown-row">
                <div class="breakdown-label">Защита</div>
                <div class="breakdown-values">
                    <span class="bv-total">{{ stats.dig_total }}</span>
                    <span class="bv-eff">({{ stats.dig_efficiency }}%)</span>
                    <span class="bv-q">#</span><span class="bv-num">{{ stats.dig_by_quality?.perfect ?? 0 }}</span>
                    <span class="bv-q">+</span><span class="bv-num">{{ stats.dig_by_quality?.positive ?? 0 }}</span>
                    <span class="bv-q">!</span><span class="bv-num">{{ stats.dig_by_quality?.insufficient ?? 0 }}</span>
                    <span class="bv-q">-</span><span class="bv-num">{{ stats.dig_negative ?? 0 }}</span>
                    <span class="bv-q">/</span><span class="bv-num">{{ stats.dig_by_quality?.veryPositive ?? 0 }}</span>
                    <span class="bv-q err">=</span><span class="bv-num">{{ stats.dig_by_quality?.error ?? 0 }}</span>
                </div>
            </div>
            <!-- Передача -->
            <div v-if="stats.set_total > 0" class="breakdown-row">
                <div class="breakdown-label">Передача</div>
                <div class="breakdown-values">
                    <span class="bv-total">{{ stats.set_total }}</span>
                    <span class="bv-eff">({{ stats.set_efficiency }}%)</span>
                    <span class="bv-q">#</span><span class="bv-num">{{ stats.set_by_quality?.perfect ?? 0 }}</span>
                    <span class="bv-q">+</span><span class="bv-num">{{ stats.set_by_quality?.positive ?? 0 }}</span>
                    <span class="bv-q">!</span><span class="bv-num">{{ stats.set_by_quality?.insufficient ?? 0 }}</span>
                    <span class="bv-q">-</span><span class="bv-num">{{ stats.set_by_quality?.negative ?? 0 }}</span>
                    <span class="bv-q">/</span><span class="bv-num">{{ stats.set_by_quality?.invasion ?? 0 }}</span>
                    <span class="bv-q err">=</span><span class="bv-num">{{ stats.set_by_quality?.error ?? 0 }}</span>
                </div>
            </div>
            <!-- Freeball -->
            <div v-if="stats.freeball_total > 0" class="breakdown-row">
                <div class="breakdown-label">Freeball</div>
                <div class="breakdown-values">
                    <span class="bv-total">{{ stats.freeball_total }}</span>
                    <span class="bv-q">#</span><span class="bv-num">{{ stats.freeball_perfect ?? 0 }}</span>
                    <span class="bv-q">+</span><span class="bv-num">{{ stats.freeball_positive ?? 0 }}</span>
                    <span class="bv-q">!</span><span class="bv-num">{{ stats.freeball_neutral ?? 0 }}</span>
                    <span class="bv-q">-</span><span class="bv-num">{{ stats.freeball_negative ?? 0 }}</span>
                    <span class="bv-q">/</span><span class="bv-num">{{ stats.freeball_slash ?? 0 }}</span>
                    <span class="bv-q err">=</span><span class="bv-num">{{ stats.freeball_error ?? 0 }}</span>
                </div>
            </div>
        </div>
        <div v-if="!hasAnyStats" class="breakdown-empty">Нет данных за выбранный период</div>
    </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
    stats: {
        type: Object,
        default: () => ({})
    }
});

const hasAnyStats = computed(() => {
    const s = props.stats;
    return (s.attack_total > 0) || (s.serve_total > 0) || (s.block_total > 0) || (s.reception_total > 0) || (s.dig_total > 0) || (s.set_total > 0) || (s.freeball_total > 0);
});
</script>

<style scoped>
.player-stats-breakdown {
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 6px;
    padding: 0.75rem 1rem;
    margin-bottom: 1.5rem;
}

.breakdown-title {
    font-size: 0.75rem;
    font-weight: 600;
    color: #64748b;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    margin-bottom: 0.6rem;
}

.breakdown-table {
    display: flex;
    flex-direction: column;
    gap: 0.35rem;
}

.breakdown-row {
    display: flex;
    align-items: baseline;
    gap: 0.75rem;
    padding: 0.35rem 0;
    border-bottom: 1px solid #e2e8f0;
    font-size: 0.8rem;
}

.breakdown-row:last-child {
    border-bottom: none;
}

.breakdown-label {
    min-width: 5rem;
    color: #475569;
    font-weight: 500;
}

.breakdown-values {
    display: flex;
    align-items: baseline;
    flex-wrap: wrap;
    gap: 0.25rem 0.5rem;
}

.bv-total {
    font-weight: 600;
    color: #334155;
    margin-right: 0.15rem;
}

.bv-eff {
    color: #64748b;
    font-size: 0.7rem;
    margin-right: 0.35rem;
}

.bv-q {
    color: #94a3b8;
    font-weight: 600;
    min-width: 1ch;
}

.bv-q.err {
    color: #94a3b8;
}

.bv-num {
    color: #334155;
    font-variant-numeric: tabular-nums;
    min-width: 1.2ch;
}

.breakdown-empty {
    font-size: 0.8rem;
    color: #94a3b8;
    padding: 0.5rem 0;
}
</style>
